import Vue from 'vue';
import moment from 'moment';
import numeral from 'numeral';
import _ from 'lodash';

function isValid (val) {
 return moment(val).isValid() && (val !== null && val !== '' && val !== undefined)
}

Vue.filter('shortDateWithDay', function (val) {
  return isValid(val) ? moment(val).format('ddd MMM D, YYYY') : null
})

Vue.filter('longDateWithDay', function (val) {
  return isValid(val) ? moment(val).format('dddd MMMM D, YYYY') : null
})

Vue.filter('longDateWithDayAtEnd', function (val) {
  return isValid(val) ? moment(val).format('MMMM D, YYYY [ - ] dddd') : null
})

Vue.filter('longDate', function (val) {
  return isValid(val) ? moment(val).format('MMMM D, YYYY') : null
})

Vue.filter('shortDate', function (val) {
  return isValid(val) ? moment(val).format('MMM D, YYYY') : null
})

Vue.filter('longMonth', function (val) {
  return isValid(val) ? moment(val).format('MMMM Do') : null
})

Vue.filter('time', function (val) {
  // Format of the value coming in must be ##:##:##
  return moment(val, 'hh:mm:ss').isValid() ? moment(val, 'hh:mm:ss').format('h:mm A') : null
})

Vue.filter('shortTime', function (val) {
  // Format of the value coming in must be ##:##:##
  return moment(val, 'hh:mm:ss').isValid() ? moment(val, 'hh:mm:ss').format('h:mm') : null
})

Vue.filter('dateTime', function (val) {
  // Format of the value coming in must be ##:##:##
  // return val
  return moment(val, 'YYYY-MM-DD[T]hh:mm:ss.SSSSSS[Z]').isValid() ? moment(val, 'YYYY-MM-DD[T]hh:mm:ss.SSSSSS[Z]').format('MMM D, YYYY h:mm A') : null
})

Vue.filter('dateTimeShortDate', function (val) {
  // Format of the value coming in must be ##:##:##
  // return val
  return moment(val, 'YYYY-MM-DD[T]hh:mm:ss.SSSSSS[Z]').isValid() ? moment(val, 'YYYY-MM-DD[T]hh:mm:ss.SSSSSS[Z]').format('MMM D, YYYY') : null
})

Vue.filter('dateTimeTime', function (val) {
  // Format of the value coming in must be ##:##:##
  // return val
  return moment(val, 'YYYY-MM-DD[T]hh:mm:ss.SSSSSS[Z]').isValid() ? moment(val, 'YYYY-MM-DD[T]hh:mm:ss.SSSSSS[Z]').format('h:mm A') : null
})

Vue.filter('dateNoYear', function (val) {
  return isValid(val) ? moment(val).format('MMMM D') : null
})

Vue.filter('shortDateNoYear', function (val) {
  return isValid(val) ? moment(val).format('MMM D') : null
})

Vue.filter('trueFalse', function (val) {
  if (val) {
    return 'Yes'
  }
  return 'No'
})

Vue.filter('int', function (val) {
  if (val) {
    return numeral(val).format('0,0')
  }
  return 0
})


Vue.filter('reportAmount', function (val) {
  if (val !== '' && val !== null) {
    // This rounds it to 2 decimal places, without converting it to a string
    val = Math.round(val * 100) / 100
    if (val == 0) {
      return '-'
    }
    if (val < 0) {
      return numeral(val).format('(0,0.00)')
    }
    return numeral(val).format('0,0.00')
  }
  return _.isString(val) ? 'ERR' : '-'
})

Vue.filter('decAccounting', function (val) {
  if (val !== '') {
    // This rounds it to 2 decimal places, without converting it to a string
    val = Math.round(val * 100) / 100
    if (val < 0) {
      return numeral(val).format('(0,0.00)')
    }
    return numeral(val).format('0,0.00')
  }
  return '0.00'
})

Vue.filter('dec', function (val) {
  if (val !== '') {
    return numeral(val).format('0,0.00')
  }
  return '0.00'
})

Vue.filter('decMoney', function (val) {
  if (val !== '') {
    return numeral(val).format('$0,0.00')
  }
  return '$ 0.00'
})

Vue.filter('intMoney', function (val) {
  return numeral(val).format('$0,0')
})

Vue.filter('percentage', function (val) {
  if (val) {
    return numeral(val / 100).format('0.00 %')
  }
  return ''
})

Vue.filter('phone', function (val) {
  if (val) {
    let area = val.slice(0,3)
    let pre = val.slice(3,6)
    let post = val.slice(6,10)
    return '(' + area + ') ' + pre + '-' + post
  }
  return ''
})

Vue.filter('postal', function (val) {
  return val.toUpperCase();
})
